// DesktopOnly wrapper — historically hid management pages on mobile.
// Now a pass-through: all pages work on any screen size for every role.
// Kept as a stable component so existing routes don't need edits.
export default function DesktopOnly({ children }) {
  return children;
}
